/**
 * 
 * @param {string} str — the string to convert to kebab case.
 * @returns {string} — the kebab-cased string.
 */
export default function stringToKebabCase(str) {
  if (!str) return '';

  return str
    .toLowerCase()
    .replace(/ą/g, 'a')
    .replace(/ć/g, 'c')
    .replace(/ę/g, 'e')
    .replace(/ł/g, 'l')
    .replace(/ń/g, 'n')
    .replace(/ó/g, 'o')
    .replace(/ś/g, 's')
    .replace(/ź/g, 'z')
    .replace(/ż/g, 'z')
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/\s+/g, '-');
}
